import { render } from "./EventID.vue?vue&type=template&id=6b81788c"
import script from "./EventID.vue?vue&type=script&lang=js"
export * from "./EventID.vue?vue&type=script&lang=js"

import exportComponent from "/builds/weborigo-projects/vivien-vance/core-frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__